import React from 'react';
import { NavLink } from 'react-router-dom';

const BottomNavigationBar = () => {
  const items = [
    { to: '/dashboard/audios', icon: '🎧', label: 'Audios' },
    { to: '/dashboard/quiz', icon: '📋', label: 'Quizz' },
    { to: '/dashboard/simulador', icon: '🚢', label: 'Simulador' },
    { to: '/dashboard/plan-estudio', icon: '🗂️', label: 'Planes' },
    { to: '/dashboard/tutorials', icon: '🎞️', label: 'Videos' },
  ];

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      minHeight: '60px',
      background: 'rgba(13, 32, 53, 0.92)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)', // iOS support
      borderTop: '1px solid rgba(197, 160, 89, 0.3)',
      boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.5)',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 1000,
      paddingTop: '6px',
      paddingBottom: 'calc(6px + env(safe-area-inset-bottom, 0px))', // Notch support
    }} className="bottom-nav-mobile">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          style={({ isActive }) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            textDecoration: 'none',
            color: isActive ? '#c5a059' : 'rgba(181, 200, 216, 0.65)',
            transition: 'color 0.2s ease, transform 0.2s ease, background-color 0.2s ease',
            flex: 1,
            height: '100%',
            WebkitTapHighlightColor: 'transparent',
          })}
          className="active-scale"
        >
          <span aria-hidden="true" style={{ fontSize: '1.25rem', lineHeight: 1 }}>{item.icon}</span>
          <span style={{
            fontFamily: "'Orbitron', sans-serif",
            fontSize: '0.55rem',
            fontWeight: 700,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
          }}>{item.label}</span>
        </NavLink>
      ))}
    </div>
  );
};

export default BottomNavigationBar;
